// extracted by mini-css-extract-plugin
export default {"galeries":"Galery_galeries__opemn","content":"Galery_content__16YX0","img":"Galery_img__hQ0Xo","addedClass":"Galery_addedClass__BTglc"};